class SaleNotice extends HTMLElement {
  connectedCallback() {
    const notices = window.NostoSaleNotice;
    if (!notices || !notices.length) return;

    const today = new Date();
    const pad = (n) => String(n).padStart(2, '0');
    const todayStr = `${today.getFullYear()}${pad(today.getMonth() + 1)}${pad(today.getDate())}`;

    const productTags = (this.dataset.productTags || '').split(',').map((t) => t.trim()).filter(Boolean);
    const collectionIds = (this.dataset.collectionIds || '').split(',').map((c) => c.trim()).filter(Boolean);

    let match = null;

    for (const notice of notices) {
      if (!notice.notice) continue;
      if (notice.start_date && todayStr < notice.start_date) continue;
      if (notice.end_date && todayStr >= notice.end_date) continue;

      const noticeTags = (notice.tags || []).filter((t) => t.trim());
      const noticeCollections = (notice.collections || []).filter((c) => c.trim());

      const tagMatch = noticeTags.length && noticeTags.some((t) => productTags.includes(t.trim()));
      const colMatch = noticeCollections.length && noticeCollections.some((c) => collectionIds.includes(c.trim()));

      if (tagMatch || colMatch) {
        match = notice;
        break;
      }
    }

    if (!match) return;

    const span = document.createElement('span');
    span.style.cssText = `margin-top: 0.7rem;`;

    if (match.font_color && match.font_color.includes('#')) {
      span.style.color = match.font_color;
    }

    span.innerHTML = match.notice;
    this.style.cssText = 'margin-top: auto; display: block;';
    this.appendChild(span);
  }
}

customElements.define('sale-notice', SaleNotice);
